<template>
  <div>
    <InterventionForm
      :show="addIntervention"
      :patId="patId"
      @close="addIntervention = false; editInterventionForm = null"
      @marked="addedIntervention"
      :edit="editInterventionForm"
      :key="'technical-intervention-' + patId"
    />
    <Card class="p-no-shadow-app">
      <template #title>Intervenções</template>
      <template #content>
        <div class="p-field p-col-12 p-md-10">
          <Button
            label="Adicionar Intervenção Técnica"
            icon="pi pi-plus"
            class="p-button-info p-button-sm"
            @click="addIntervention = true"
            v-if="can('createPatIntervention')"
          />
        </div>
        <div style="height: 65vh">
          <DataTable
            :value="interventions"
            :loading="loading"
            responsiveLayout="scroll"
            class="p-datatable-sm"
            scrollable
            scrollHeight="flex"
            :autoLayout="true"
          >
            <Column
              header="Dia"
            >
              <template #body="slotProps">
                {{ formatDate(slotProps.data.start) }}
              </template>
            </Column>
            <Column
              header="Inicio"
            >
              <template #body="slotProps">
                {{ formatHour(slotProps.data.start) }}
              </template>
            </Column>
            <Column
              header="Fim"
            >
              <template #body="slotProps">
                {{ formatHour(slotProps.data.end) }}
              </template>
            </Column>
            <Column
              field="technician"
              header="Técnico"
            />
            <Column
              field="type"
              header="Tipo"
            />
            <Column
              field="resume"
              header="Relatório"
            />
            <Column
              header="Valor"
            >
              <template #body="slotProps">
                {{ formatCurrency(slotProps.data.cost_value) }}
              </template>
            </Column>
            <Column header="Confirmação do Cliente">
              <template #body="slotProps">
              <PreviewReport
                v-if="slotProps.data.status && slotProps.data.status.report_file_url"
                :filename="slotProps.data.status.report_file_url"
              />
              <span v-else>Sem ficheiro</span>
              </template>
            </Column>
            <Column header="Técnica Final">
              <template #body="slotProps">
                <PreviewReportTechnicalFinal
                  v-if="['Tecnica', 'DMS', 'Técnica Final'].includes(slotProps.data.type)"
                  :taskId="slotProps.data.id"
                  :patId="patId"
                  code="technical_final"
                />
              </template>
            </Column>
            <Column
              header="Ações"
              style="width: 8rem"
            >
              <template #body="slotProps">
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-button-text"
                  v-tooltip.top="'Editar'"
                  @click="editIntervention(slotProps.data)"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import PatService from "@/services/pat.service";
import InterventionForm from "@/components/pats/InterventionForm.vue";
import { getOnlyDate, getOnlyTime } from "@/helpers/helpers";
import PreviewReport from "../elements/PreviewReport.vue";
import PreviewReportTechnicalFinal from "./PreviewReportTechnicalFinal.vue";

export default {
  name: "InterventionsInfo",
  props: {
    patId: {
      type: Number,
      required: true,
    },
  },
  components: { InterventionForm, PreviewReport, PreviewReportTechnicalFinal },
  data() {
    return {
      loading: false,
      addIntervention: false,
      interventions: [],
      editInterventionForm: null,
    };
  },
  computed: {},
  async mounted() {
    this.loading = true;
    this.interventions = await PatService.getInterventions(this.patId);
    return (this.loading = false);
  },
  methods: {
    editIntervention(intervention) {
      this.editInterventionForm = intervention;
      this.addIntervention = true;
    },
    formatDate(date) {
      return date ? getOnlyDate(new Date(date)) : "";
    },
    formatHour(date) {
      return date ? getOnlyTime(new Date(date)) : "";
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: 'EUR'
      }).format(value || 0);
    },
    async addedIntervention() {
      this.interventions = await PatService.getInterventions(this.patId);
      return (this.addIntervention = false);
    },
  },
};
</script>
